import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { productApi } from "./product";
import { adApi } from "./ad";
import { campaignApi } from "./campaign";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_BASE_SERVER_URL,
    // we can also write this function on the "getUser" endpoint level
    // bc technically, we're not gonna be sending a token for the login request
    // but the way it's written right now is completely fine too
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    login: builder.mutation({
      // the "payload" is renamed "credentials" here
      query: (credentials) => ({
        url: "/api/glabp/",
        method: "POST",
        body: credentials,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(productApi.util.resetApiState());
          dispatch(adApi.util.resetApiState());
          dispatch(campaignApi.util.resetApiState());
        } catch (error) {
          console.log(error);
        }
      },
    }),
    // this would need to be created on the backend, if we want to go with this approach
    // this is just a placeholder for now
    getUser: builder.query({
      query: () => "/api/user/me",
      providesTags: ["User"],
    }),
  }),
});

export const { useLoginMutation, useGetUserQuery } = userApi;
